import axios from "axios";

// Configure axios to send credentials (cookies) with every request
axios.defaults.withCredentials = true;

export default axios;
